import React from 'react'

import SidebarTag from './SidebarTag'
import SidebarResources from './SidebarResources'

import { sidebar } from './Sidebar.module.scss'

const Sidebar = ({
  className,
  microcopy,
  tags,
  resources,
  location
}) => (
  <aside id='sidebar' className={className}>
    <div className={sidebar}>
      <h1>
        { microcopy.text('reference.titles.api_reference') }
      </h1>
      <ul>
        { tags.filter(notEmpty).map((tag) => (
          <SidebarTag
            key={tag.id}
            tag={tag}
            location={location} />
        ))}
        <SidebarResources 
          selected
          microcopy={microcopy}
          resources={resources}
          location={location} />
      </ul>
    </div>
  </aside>
)

const notEmpty = tag => tag.resources?.[0] || tag.endpoints?.[0]

export default Sidebar